import type { ComponentType } from 'react';

type EmptyProps = {
  icon: ComponentType<{ size?: number }>;
  title: string;
  text?: string;
};

export default function Empty({ icon: Icon, title, text }: EmptyProps) {
  return (
    <div className="empty">
      <div><Icon size={32} /></div>
      <h3>{title}</h3>
      {text && <p>{text}</p>}
    </div>
  );
}
